// Convert currency to a set amount of fractional digits
export const currencyFormatter = function (value) {
  let minimumFractionDigits = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
  let maximumFractionDigits = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 2;
  return Intl.NumberFormat('en-GB', {
    currency: 'GBP',
    minimumFractionDigits,
    maximumFractionDigits,
    style: 'currency'
  }).format(value);
};